import styled from "styled-components";
import {Link} from "../../../../../raw-components/link/link";
import { CssRule } from "../../../../../../themes/architecture/css-helpers/css-rule";

export const LiveCasinoArenaNavbarButtonDefaultBox = styled(Link)`
  display: flex;
  margin: 0 0.25em;
  padding: 1em 1em 0 1em;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 88px;

  &:hover {
    cursor: pointer;
  }

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    margin: 0;
    padding: 1em;
    border-right: 1px solid ${props => props.theme.colors.buttonDark};
    background-color: ${props => props.theme.components.newLiveCasino.colors.filterButtonBackground};

    &:last-child {
      border: none;
    }

    ${CssRule.For.mobile.landscape.build()} &, ${CssRule.For.ipad.build()} & {
      flex: 1;
    }

  }
`;
